import { SearchFormFieldWrapper } from '..';
import { DatePicker, type DatePickerSlotProps } from '@mui/x-date-pickers';
import { isEarlier, isLater } from './dateUtils';
import { type Moment } from 'moment';
import Space from '@/components/Space';

type SearchFormDateRangeProps = {
  startDate: Moment | null;
  onChangeStartDate: (date: Moment | null) => void;
  endDate: Moment | null;
  onChangeEndDate: (date: Moment | null) => void;
};

const datePickerSlotProps = {
  textField: {
    variant: 'filled',
    size: 'small',
  },
} satisfies DatePickerSlotProps;

const SearchFormDateRange = ({
  startDate,
  onChangeStartDate,
  endDate,
  onChangeEndDate,
}: SearchFormDateRangeProps) => (
  <SearchFormFieldWrapper>
    <DatePicker
      label="Start date"
      value={startDate}
      onChange={onChangeStartDate}
      shouldDisableDate={
        endDate === null ? undefined : date => isLater(date, endDate)
      }
      slotProps={datePickerSlotProps}
    />
    <Space width={12} />
    <DatePicker
      label="End date"
      value={endDate}
      onChange={onChangeEndDate}
      shouldDisableDate={
        startDate === null ? undefined : date => isEarlier(date, startDate)
      }
      slotProps={datePickerSlotProps}
    />
  </SearchFormFieldWrapper>
);

export default SearchFormDateRange;
